const polish = () => {
    const html = document.documentElement;
    return [html.lang, html.dataset.lang, html.dataset.locale]
        .some(value => value?.toLowerCase().startsWith('pl'));
};

const messages = {
    cs: {
        attach: '+ Přiložit', displayed: 'Zobrazeno', loading: 'Vyhledávání…',
        loadError: 'Výsledky nemohly být načteny.', empty: 'Nenalezeny žádné položky.',
    },
    pl: {
        attach: '+ Załącz', displayed: 'Wyświetlono', loading: 'Wyszukiwanie…',
        loadError: 'Nie udało się załadować wyników.', empty: 'Nie znaleziono żadnych pozycji.',
    },
};

export const portalText = key => messages[polish() ? 'pl' : 'cs'][key];
